import { Card } from "../../ui/card";

function Row({ label, value, points, valueIsLink }) {
  return (
    <tr className="border-b border-[#000000]">
      <td className="py-3 px-2 sm:py-4 sm:px-4 align-top text-[12px] sm:text-[14px] md:text-[15px] break-words content-center w-[65%]">
        <div className="flex flex-col items-start justify-center">
          <span>{label}</span>
          <span
            className={[
              "text-primary text-[#005787] text-[12px] sm:text-[14px] md:text-[15px]",
              valueIsLink
                ? "underline decoration-muted-foreground/40 underline-offset-2"
                : "",
            ].join(" ")}
          >
            {value}
          </span>
        </div>
      </td>
      {/* <td className="py-3 px-2 sm:py-4 sm:px-4 align-top break-words content-center w-[40%]">
        <span
          className={[
            "text-primary text-[#005787] text-[12px] sm:text-[14px] md:text-[15px]",
            valueIsLink
              ? "underline decoration-muted-foreground/40 underline-offset-2"
              : "",
          ].join(" ")}
        >
          {value}
        </span>
      </td> */}
      <td className="py-3 px-2 sm:py-4 sm:px-4 align-top text-muted-foreground text-[11px] sm:text-xs md:text-sm text-[#00000066] text-right content-center w-[35%]">
        {points ? points : ""}
      </td>
    </tr>
  );
}

export default function SummaryTable({
  age,
  maritalStatus,
  partner,
  dependent,
  employed,
  englishLanguage,
  highestQualification,
  isCurrentlyStudying,
  skillAssessment,
  meetAustralianStudyRequirements,
  naati,
  purpose,
  overseasEmployement,
  australianSkilledEmployment,
  isCompletedProfessionalYearAus,
  courses,
  agePoints,
  englishLanguagePoints,
  highestEducationPoints,
  meetAustralianStudyPoints,
  masterResearchPoints,
  nattiPoints,
  regionalAustralianQualification,
  partnerPoints,
  overseasEmployementPoints,
  overseasJobTitle,
  overseasJobCompanyName,
  overseasJobCompanyCountry,
  overseasJobCompanyCity,
  overseasJobDurationFrom,
  overseasJobDurationTo,
  overseasJobIsWorking,
  regionalAustralianQualificationPoints,
  australianSkilledEmploymentPoints,
  isCompletedProfessionalYearAusPoints,
  currentAgent,
  university,
  degree,
}) {
  // console.log(
  //   {
  //     age,
  //     maritalStatus,
  //     partner,
  //     dependent,
  //     employed,
  //     englishLanguage,
  //     highestQualification,
  //     isCurrentlyStudying,
  //     skillAssessment,
  //     meetAustralianStudyRequirements,
  //     naati,
  //     purpose,
  //     overseasEmployement,
  //     australianSkilledEmployment,
  //     isCompletedProfessionalYearAus,
  //     agePoints,
  //     englishLanguagePoints,
  //     highestEducationPoints,
  //     meetAustralianStudyPoints,
  //     masterResearchPoints,
  //     nattiPoints,
  //     regionalAustralianQualification,
  //     partnerPoints,
  //     overseasEmployementPoints,
  //     australianSkilledEmploymentPoints,
  //     isCompletedProfessionalYearAusPoints,
  //     currentAgent,
  //     university,
  //     degree,
  //   },
  //   "ldjf",
  // );

  return (
    <Card className="mt-4 overflow-hidden border-none shadow-none">
      <div className="w-full overflow-x-auto rounded-md">
        <table className="w-full text-[12px] sm:text-[14px] md:text-[15px] border-none min-w-[500px] table-fixed">
          <tbody>
            <Row label="Age" value={age} points={`( ${agePoints} Points)`} />
            <Row label="Marital Status" value={maritalStatus} points="" />
            <Row
              label="Partner Skills"
              value={partner}
              points={`( ${partnerPoints} Points)`}
            />
            <Row label="Dependents" value={dependent || 0} points="" />
            <Row label="Employed" value={employed} points="" />
            <Row
              label="Overseas Employement (outside Australia) *"
              value={overseasEmployement}
              points={`( ${overseasEmployementPoints} Points)`}
            />
            {/* Overseas Employement Details */}
            <tr className="border-b border-[#000000]">
              <td className="py-3 px-2 sm:py-4 sm:px-4 align-top text-[12px] sm:text-[14px] md:text-[15px] break-words content-center w-[65%]">
                <div className="flex flex-col items-start justify-center">
                  <span>Overseas Employement Details</span>
                  <span
                    className={
                      "text-primary text-[#005787] text-[12px] sm:text-[14px] md:text-[15px] flex flex-col items-start justify-center gap-1"
                    }
                  >
                    <span>
                      {overseasJobTitle} at {overseasJobCompanyName},{" "}
                      {overseasJobCompanyCountry}, {overseasJobCompanyCity}
                    </span>
                    <span>
                      From {overseasJobDurationFrom?.split("T")[0] || "--"}
                    </span>
                    {overseasJobIsWorking ? (
                      <span>Currently Employed</span>
                    ) : (
                      <span>
                        To {overseasJobDurationTo?.split("T")[0] || "--"}
                      </span>
                    )}
                  </span>
                </div>
              </td>
            </tr>
            <Row
              label="Australian Skilled Employement (inside Australia)"
              value={australianSkilledEmployment}
              points={`( ${australianSkilledEmploymentPoints} Points)`}
            />
            <Row
              label="Highest Education Qualified"
              value={highestQualification}
              points={`( ${highestEducationPoints} Points)`}
            />
            <Row
              label="English Language"
              value={englishLanguage}
              points={`( ${englishLanguagePoints} Points)`}
            />
            <Row
              label="Are you currently studying?"
              value={isCurrentlyStudying ? "Yes" : "No"}
              // points={`( ${highestEducationPoints} Points)`}
            />
            {/* Courses */}
            <tr className="border-b border-[#000000]">
              <td className="py-3 px-2 sm:py-4 sm:px-4 align-top text-[12px] sm:text-[14px] md:text-[15px] break-words content-center w-[65%]">
                <div className="flex flex-col items-start justify-center">
                  <span>Courses</span>
                  {courses?.length > 0
                    ? courses?.map((eachCourse, idx) => (
                        <span
                          key={idx}
                          className={
                            "text-primary text-[#005787] text-[12px] sm:text-[14px] md:text-[15px] flex flex-col items-start justify-center gap-1 mt-2"
                          }
                        >
                          <span>
                            <span className="text-[#1e2939]">Course: </span>
                            {eachCourse?.australianCourseName}
                          </span>
                          <span>
                            <span className="text-[#1e2939]">
                              University/College:{" "}
                            </span>
                            {eachCourse?.australianUniversityName}
                          </span>
                          <span className="flex items-center gap-2">
                            <span>
                              <span className="text-[#1e2939]">From: </span>
                              {eachCourse?.australianCourseStartDate?.split(
                                "T",
                              )[0] || "--"}
                            </span>
                            <span>
                              <span className="text-[#1e2939]">To: </span>
                              {eachCourse?.australianCourseEndDate?.split(
                                "T",
                              )[0] || "--"}
                            </span>
                          </span>
                        </span>
                      ))
                    : null}
                </div>
              </td>
            </tr>
            <Row
              label="Do you have at least 1 qualification from an Australian educational institution that meets the Australian study requirement?"
              value={
                meetAustralianStudyRequirements === true
                  ? "Yes"
                  : meetAustralianStudyRequirements === false
                    ? "No"
                    : "-"
              }
              points={`( ${meetAustralianStudyPoints} Points)`}
            />
            <Row
              label="Have you passed the NAATI?"
              value={naati ? "Yes" : "No"}
              points={`( ${nattiPoints} Points)`}
            />
            <Row
              label="Have you studied and lived for at least two years (92 weeks or more) in a regional area?"
              value={regionalAustralianQualification ? "Yes" : "No"}
              points={`( ${regionalAustralianQualificationPoints} Points)`}
            />
            <Row
              label="Did you complete a professional year in Australia?"
              value={isCompletedProfessionalYearAus ? "Yes" : "No"}
              points={`( ${isCompletedProfessionalYearAusPoints} Points)`}
            />
            <tr className="border-b border-[#000000]">
              <td className="py-3 px-2 sm:py-4 sm:px-4 align-top text-[12px] sm:text-[14px] md:text-[15px] break-words content-center w-[65%]">
                <div className="flex flex-col items-start justify-center">
                  <span>Overseas Education Details</span>
                  <span
                    className={
                      "text-primary text-[#005787] text-[12px] sm:text-[14px] md:text-[15px] flex flex-col items-start justify-center gap-1"
                    }
                  >
                    <span>
                      <span className="text-[#1e2939]">Course Name: </span>
                      {degree}
                    </span>
                    <span>
                      <span className="text-[#1e2939]">
                        University/College:{" "}
                      </span>
                      {university}
                    </span>
                  </span>
                </div>
              </td>
            </tr>
            {/* <Row label="Skill Assessment" value={skillAssessment} points="" /> */}
            <Row
              label="Current Agent"
              value={currentAgent}
              // points={`( ${masterResearchPoints} Points)`}
            />
            <tr className="border-t border-[#000000]">
              <td className="py-3 px-2 sm:py-4 sm:px-4 align-top text-[12px] sm:text-[14px] md:text-[15px] break-words w-[35%]">
                <div className="flex flex-col items-start justify-center">
                  <span>Purpose of Visit</span>
                  <span
                    className={
                      "text-primary text-[#005787] text-[12px] sm:text-[14px] md:text-[15px]"
                    }
                  >
                    {purpose}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}
